import React from 'react';
import { Zap, Clock, Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../lib/seo';

const EmergencyRepairs: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO 
        title="Electricista de Urgencias 24h Barcelona | Servicio Inmediato"
        description="Servicio de electricista urgente 24 horas en Barcelona. Reparaciones eléctricas de emergencia, respuesta en menos de 30 minutos. Electricista autorizado."
        canonical="/emergency-repairs"
        type="website"
      />
      
      <div className="py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-8">{t('emergencyPage.title')}</h1>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-gray-50 p-6 rounded-lg">
              <Clock className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('emergencyPage.features.service24h.title')}</h3>
              <p>{t('emergencyPage.features.service24h.description')}</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <Zap className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('emergencyPage.features.fastResponse.title')}</h3>
              <p>{t('emergencyPage.features.fastResponse.description')}</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <Shield className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('emergencyPage.features.licensed.title')}</h3>
              <p>{t('emergencyPage.features.licensed.description')}</p>
            </div>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-3xl font-bold mb-6">{t('emergencyPage.emergencies.title')}</h2>
            
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div>
                <h3 className="text-xl font-bold mb-4">{t('emergencyPage.emergencies.powerOutages.title')}</h3>
                <p className="mb-4">{t('emergencyPage.emergencies.powerOutages.description')}</p>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-4">{t('emergencyPage.emergencies.electricalFires.title')}</h3>
                <p className="mb-4">{t('emergencyPage.emergencies.electricalFires.description')}</p>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-4">{t('emergencyPage.emergencies.circuitBreakers.title')}</h3>
                <p className="mb-4">{t('emergencyPage.emergencies.circuitBreakers.description')}</p>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-4">{t('emergencyPage.emergencies.exposedWiring.title')}</h3>
                <p className="mb-4">{t('emergencyPage.emergencies.exposedWiring.description')}</p>
              </div>
            </div>

            <div className="bg-yellow-50 p-8 rounded-lg mb-12">
              <h2 className="text-3xl font-bold mb-6">{t('emergencyPage.whyChooseUs.title')}</h2>
              <ul className="space-y-4">
                <li>✓ {t('emergencyPage.whyChooseUs.available')}</li>
                <li>✓ {t('emergencyPage.whyChooseUs.response')}</li>
                <li>✓ {t('emergencyPage.whyChooseUs.licensed')}</li>
                <li>✓ {t('emergencyPage.whyChooseUs.pricing')}</li>
                <li>✓ {t('emergencyPage.whyChooseUs.equipment')}</li>
                <li>✓ {t('emergencyPage.whyChooseUs.warranty')}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmergencyRepairs;